import { Label } from "@/components/ui/label";
import { TM_PAGE_DEFS } from "@/lib/tmPages";

export function TmPagesPicker({ value, onChange, testid = "tm-pages" }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div data-testid={testid}>
      <Label className="text-xs">Pages this manager can open</Label>
      <div className="mt-1 grid grid-cols-2 gap-1.5">
        {TM_PAGE_DEFS.map((p) => (
          <label key={p.key} className={`flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-sm cursor-pointer transition-colors ${value.includes(p.key) ? "border-blue-500 bg-blue-50 text-blue-900" : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`}>
            <input type="checkbox" checked={value.includes(p.key)} onChange={() => toggle(p.key)} data-testid={`${testid}-${p.key}`} />{p.label}
          </label>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-1">Dashboard and My profile are always available. Everything stays limited to their terminal's drivers and units.</p>
    </div>
  );
}
